__turbopack_context__.v({
  "backgroundImages": "uMuvOq_backgroundImages",
  "container": "uMuvOq_container",
  "content": "uMuvOq_content",
  "ctaWrapper": "uMuvOq_ctaWrapper",
  "heading": "uMuvOq_heading",
  "imageItem": "uMuvOq_imageItem",
  "leftImages": "uMuvOq_leftImages",
  "mobileImage": "uMuvOq_mobileImage",
  "rightImages": "uMuvOq_rightImages",
  "subheading": "uMuvOq_subheading",
});
